import Common from '../Common/Constants'
import axios from 'axios'
import AlertModal from '../Common/AlertModal'
import Vue from 'vue'

import VueAdsTableTree from 'vue-ads-table-tree';


export default {
    name: "Settings",
    components: {AlertModal,VueAdsTableTree},
    data() {
        return {
            constant: Common,
            alertDialog: false,
            msg: '',
            delDialog: false,
            delData: {},
            valid: false,
            successToast: {
                theme: "primary",
                position: "top-right",
                duration: 3000,
                className: 'success-toast'
            },
            addCategoryDialog: false,
            categoryDialog:
                false,
            addEditFlag:
                false,
            category: {
                name: '',
                categoryId: ''
            },
            categoriesArr:
                [],
            fieldRules:
                [
                    v => !!v || 'This field is required',
                ],
            loader: false,

        }

    },
    created() {
        // this.getCategories();
    },
    computed: {
        propList() {
            return Object.keys(this.props).map(item => ({
                name: item,
            }));
        },
    },
    methods: {
        goToKBFolder(){
          this.$router.push('/settings/knowledgebase-folder')
        },
        getCategories() {
            let self = this;
            self.loader = true;
            self.categoriesArr = [];
            self.msg = '';
            axios.get(self.constant.apiUrl + 'getKnowledgeBaseCategories')
                .then(response => {
                    if (response.data.flag) {
                        self.categoriesArr = response.data.data;
                        self.loader = false;
                    } else {
                        self.loader = false;
                        self.alertDialog = true;
                        self.msg = response.data.message;
                    }
                })
        },
        openCategoryDialog() {
            let self = this;
            this.getCategories();
            self.categoryDialog = true;
        },
        openAddCategoryDialog() {
            let self = this;
            self.category = {};
            self.$refs.form.reset();
            self.addEditFlag = false;
            self.addCategoryDialog = true;
        },
        openEditCategoryDialog(data) {
            let self = this;
            self.category = {
                name: data.name,
                categoryId: data.id,
            };
            self.addEditFlag = true;
            self.addCategoryDialog = true;
        },
        addCategory() {
            let self = this;
            delete self.category.categoryId;
            if (self.valid) {
                axios.post(self.constant.apiUrl + 'addKnowledgeBaseCategories', self.category)
                    .then(res => {
                        if (res.data.flag) {
                            self.$toasted.show('Category Added', self.successToast);
                            self.categoriesArr.unshift(res.data.data)
                            self.cancelAddCategoryDialog();
                        }
                        else {
                            self.alertDialog = true;
                            self.msg = '';
                            self.msg = res.data.message;
                        }
                    })
                    .catch((handle) => {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = "Please fill valid details";
                    })
            } else {
                self.alertDialog = true;
                self.msg = '';
                self.msg = "Please fill all details";
            }

        },
        updateCategory() {
            let self = this;
            let request = {
                "name": self.category.name,
                "categoryId": self.category.categoryId
            };
            axios.put(self.constant.apiUrl + 'updateKnowledgeBaseCategories', request)
                .then(res => {
                    if (res.data.flag) {
                        self.$toasted.show('Category Updated', self.successToast);
                        let response = res.data.data
                        self.categoriesArr.forEach(function (val) {
                            if (val.id === response.id) {
                                val.name = response.name
                            }
                        });
                        self.$forceUpdate()
                        self.cancelAddCategoryDialog();
                    }
                    else {
                        self.alertDialog = true;
                        self.msg = '';
                        self.msg = res.data.message;
                    }
                })
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                    // self.msg = "Please fill valid details";
                })

        },
        openDelDialog(data) {
            let self = this;
            self.delDialog = true;
            self.delData = {};
            self.delData = data;
        },
        deleteCategory() {
            let self = this;
            let a = self.delData;
            const index = self.categoriesArr.indexOf(a);
            let id = self.categoriesArr[index].id;
            axios.delete(self.constant.apiUrl + 'deleteKnowledgeBaseCategories/' + id)
                .then(function (res) {
                    if (res.data.flag) {
                        self.$toasted.show('Category Deleted', self.successToast);
                        self.categoriesArr.splice(index, 1);
                        self.$forceUpdate()
                    }
                    else {
                        self.alertDialog = true;
                        self.msg = '';
                        // self.msg = "Can't delete category as resources associated with this category";
                        self.msg = res.data.message;
                    }
                })
                .catch((handle) => {
                    self.alertDialog = true;
                    self.msg = '';
                    self.msg = handle;
                });
            self.delDialog = false
        },
        cancelCategoryDialog() {
            this.categoryDialog = false;
        },
        cancelAddCategoryDialog() {
            this.addCategoryDialog = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Settings/Settings.js